import { drawCompareChart } from "./recommended_news/recommended_news";
import { recommendChartInit } from "./recommended_news/recommend_chart";
import { topSpiderChartInit } from "./recommended_news/top_spider_chart";
import "./recommended_news/common"

window.drawCompareChart = drawCompareChart
window.recommendChartInit = recommendChartInit
window.topSpiderChartInit = topSpiderChartInit
